import React from "react";
import { Search, Download } from "lucide-react";

const AdminFilters = ({
  query,
  onQueryChange,
  sourceFilter,
  onSourceFilterChange,
  onExportCsv,
}) => (
  <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
    <div className="flex flex-col sm:flex-row gap-3 flex-1">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#9aa6b2]" />
        <input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search by name or email…"
          className="ht-input w-full rounded-md border border-[#dbe3eb] bg-white pl-10 pr-3 py-2.5 text-sm placeholder:text-[#9aa6b2]"
        />
      </div>
      <select
        value={sourceFilter}
        onChange={(e) => onSourceFilterChange(e.target.value)}
        className="ht-input rounded-md border border-[#dbe3eb] bg-white px-3 py-2.5 text-sm text-[#2c3e50]"
      >
        <option value="all">All sources</option>
        <option value="hero">Hero form</option>
        <option value="final_cta">Final CTA</option>
      </select>
    </div>
    <button
      onClick={onExportCsv}
      className="ht-btn inline-flex items-center justify-center gap-2 rounded-md bg-[#3d6486] hover:bg-[#345674] text-white px-4 py-2.5 text-sm font-semibold"
    >
      <Download className="h-4 w-4" /> Export CSV
    </button>
  </div>
);

export default AdminFilters;
